import { useMemo } from "react";

const useHeaderCustomLabelsItem = (cardFilter, dynamicCards, defaultHeaderItems) => {
    return useMemo(() => {
        const normalizeKey = (value = "") => String(value).trim().toLowerCase();
        const stripCustomTabSuffix = (value = "") => String(value).replace(/customtab$/i, "");
        const prettifyFallbackLabel = (value = "") =>
            String(value)
                .replace(/customtab$/i, "")
                .replace(/[_-]+/g, " ")
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .trim();

        const getCustomLabelForKey = (key) => {
            if (!Array.isArray(dynamicCards) || dynamicCards.length === 0) return null;

            const keyNorm = normalizeKey(key);
            const keyNoSuffix = normalizeKey(stripCustomTabSuffix(key));

            const matched = dynamicCards.find((item) => {
                const accessor = normalizeKey(item?.accessor);
                const accessorNoSuffix = normalizeKey(stripCustomTabSuffix(item?.accessor || ""));
                const itemKey = normalizeKey(item?.key);
                const itemId = normalizeKey(item?.id);
                const itemMongoId = normalizeKey(item?._id);

                return (
                    accessor === keyNorm ||
                    accessorNoSuffix === keyNoSuffix ||
                    itemKey === keyNorm ||
                    itemKey === keyNoSuffix ||
                    itemId === keyNorm ||
                    itemId === keyNoSuffix ||
                    itemMongoId === keyNorm ||
                    itemMongoId === keyNoSuffix
                );
            });

            if (!matched) return null;

            return (
                matched?.title ||
                matched?.tableLabel ||
                matched?.label ||
                matched?.question?.label ||
                matched?.question?.title ||
                matched?.question?.question ||
                null
            );
        };

        if (!cardFilter) {
            return [...defaultHeaderItems];
        }

        const headerItemsDataArr = [...defaultHeaderItems];
        const cardFilterKeys = Object.keys(cardFilter);

        cardFilterKeys.forEach((key) => {
            if (key === "priorityData" || key.includes("_spacial")) return;

            const existingItemIndex = headerItemsDataArr.findIndex((item) => item.dataKey === key);

            if (existingItemIndex === -1) {
                const customLabel = getCustomLabelForKey(key) || prettifyFallbackLabel(key) || key;
                headerItemsDataArr.push({
                    label: customLabel,
                    dataKey: key,
                    isDefault: false,
                });
            }
        });

        return headerItemsDataArr;
    }, [cardFilter, defaultHeaderItems, dynamicCards]);
};

export default useHeaderCustomLabelsItem;